/**
 * Verificar se a prorpriedade e indefinida ou nula
 * @returns true, se for válido. false, inválido.
 */
export const isValidaProp = (prop) => {
    return (prop !== undefined && prop !== null && prop !== '');
};

/**
 * Verificar se o campo está em branco
 * @returns true, se for válido. false, inválido.
 */
export const isValidField = (field) => {
    return (field !== '' && field !== null);
}

/**
 * Verificar se a senha é valida
 * @returns true, se for válido. false, inválido.
 */
export const isValidPassword = (password) => {
    var valid = false;
    let hasUpper = (str) => /[A-Z]/.test(str);
    let hasSpecial = (str) => /\W|_/.test(str);
    let hasNumber = (str) => /[0-9]/.test(str);

    if(password?.length >= 8 && hasUpper(password) 
    && hasSpecial(password) && hasNumber(password)){
        valid = true;
    }

    return valid;
}

/**
 * Verificar se a senha é valida e igual a anterior
 * @returns true, se for válido. false, inválido.
 */
export const isValidPassword2 = (password, password2) => {
    var valid = false;
    let hasUpper = (str) => /[A-Z]/.test(str);
    let hasSpecial = (str) => /\W|_/.test(str);
    let hasNumber = (str) => /[0-9]/.test(str);

    if(password?.length >= 8 && hasUpper(password) 
    && hasSpecial(password) && hasNumber(password) && password === password2){
        valid = true;
    }

    return valid;
}

/**
 * Verificar se o campo é um usuário valido
 * @returns true, se for válido. false, inválido.
 */
export const isValidUser = (value)=>{
    let hasUpper = (str) => /[A-Z]/.test(str);
    let validate = (str) => /^[a-zA-Z0-9_.-]+$/.test(str);
    if(!hasUpper(value) && validate(value)){
        return true
    }else{
        return false;
    }
}

/**
 * Verificar se o campo é um número de telefone valido
 * @returns true, se for válido. false, inválido.
 */
export const isValidPhone = (phone) =>{
    const regex = /^\(\d{2}\) \d{5}-\d{4}$/;
    return regex.test(phone);
}

export const isValidWpp = (phone) =>{
    const regex = /^\(\d{2}\) \(\d{2}\) \d{4,5}-\d{4}$/;
    return regex.test(phone);
}

/**
 * Verificar se o campo é email valido
 * @returns true, se for válido. false, inválido.
 */
export const isValidEmail = (email) =>{
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

/**
 * Valida o campo para o usuário ao enviar
 */
export const ValidateField = (field) => {
    try {
        field.focus();
        field.blur();
    } catch (error) {
        try {
            field.getInputDOMNode().focus();
            field.getInputDOMNode().blur();
        } catch (error) {
            console.log('Validação 2: '+error)
        }
        console.log('Validação 1: '+error)
    }
}

export const FormatPhone = (phone) =>{
    const digitos = !phone ? '' : phone.replace(/[^\d]/g, '');
    if (!digitos || digitos.length < 10) return phone;
    const corte = digitos.length === 10 ? 6 : 7;
    const max = digitos.length > 11 ? 11 : digitos.length;
    return `(${digitos.substring(0, 2)}) ${digitos.substring(2, corte)}-${digitos.substring(corte, max)}`;
}

export const FormatWpp = (phone) =>{
    const digitos = !phone ? '' : phone.replace(/[^\d]/g, '');
    if (!digitos || digitos.length < 12) return phone;
    return `(${digitos.substring(0, 2)}) (${digitos.substring(2, 4)}) ${digitos.substring(4, 8)}-${digitos.substring(8, 13)}`;
}

export const isValidStartData = (startData, endData) => {
    try {
        let start = new Date(startData);
        let end = new Date(endData);
        return start < end;
    } catch (error) {
        return false;
    }
}

export const isValidEndData = (startData, endData) => {
    try {
        let start = new Date(startData);
        let end = new Date(endData);
        return end > start;
    } catch (error) {
        return false;
    }
}